<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <vet-service-form
    v-else
    :initVetService="initVetService"
    :successMsg="t('updated')"
    :submitAction="update"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

import { useHTTP } from '@/plugins/http'

import VetService from '@/models/VetService'
import { Route } from '@/router/routes'

// components
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import VetServiceForm from '@/views/vetServices/VetServiceForm.vue'
import AlertBadge from '@/components/AlertBadge.vue'

export default defineComponent({
  name: 'vet-service',

  components: {
    LoadingSpinner,
    VetServiceForm,
    AlertBadge
  },

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          updated: 'Vet service was updated successfully'
        },
        ar: {
          updated: 'تم تحديث الخدمة البيطرية بنجاح'
        }
      }
    })

    const initVetService = ref(new VetService())
    const error = ref({ title: '', body: '' })
    const http = useHTTP()
    const loading = ref(true)
    const route = useRoute()
    const router = useRouter()

    onBeforeMount(async () => {
      try {
        const vetServiceResp = await http.get<VetService>(
          `${VetService.ENDPOINT}/${route.params.id}`
        )
        initVetService.value = VetService.from(vetServiceResp)
      } catch (errorResp: any) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (vetService: VetService) => {
      try {
        const url = `${VetService.ENDPOINT}/${vetService.id}`
        const resp = await http.put<VetService>(url, vetService)
        initVetService.value = VetService.from(resp)
        router.push(Route.VET_SERVICES)
      } catch (error) {
        return error
      }
    }

    return {
      t,
      initVetService,
      error,
      loading,
      update
    }
  }
})
</script>

<style></style>
